var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [{ name: "title", rawName: "v-title" }],
      staticClass: "flex column",
      attrs: { "data-title": "问题详情" }
    },
    [
      _c(
        "span",
        {
          staticStyle: {
            margin: "21px 0 0 26px",
            "font-weight": "bold",
            "font-size": "18px",
            "word-wrap": "initial"
          }
        },
        [_vm._v(_vm._s(this.question.title))]
      ),
      _vm._v(" "),
      this.question.detailTitle
        ? _c(
            "span",
            {
              staticStyle: {
                margin: "14px 0 0 26px",
                "font-weight": "normal",
                "font-size": "17px",
                "word-wrap": "initial"
              }
            },
            [_vm._v(_vm._s(this.question.detailTitle))]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            margin: "14px 26px 0 26px",
            "font-weight": "normal",
            "font-size": "15px",
            "word-break": "break-all"
          }
        },
        _vm._l(_vm.question.detailTexts, function(item, index) {
          return _c("div", { key: index }, [
            item.title && _vm.question.title === "为什么找不到自己的学校？"
              ? _c("p", [
                  _vm._v(_vm._s(item.title)),
                  _c(
                    "a",
                    {
                      staticStyle: { color: "#21BEA1" },
                      attrs: { href: "tel:029-89875100" }
                    },
                    [_vm._v("029-89875100")]
                  )
                ])
              : item.title
              ? _c("p", [_vm._v(_vm._s(item.title))])
              : _vm._e(),
            _vm._v(" "),
            item.img
              ? _c("img", {
                  staticStyle: { width: "100%", height: "auto" },
                  attrs: { src: item.img }
                })
              : _vm._e()
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1eb80687", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1eb80687","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionDetail.vue
// module id = null
// module chunks = 